<template>
  <h3 class="m-2">
    ...
  </h3>
</template>

<script>

/* eslint-disable global-require */
import useJwt from '@/auth/jwt/useJwt'

export default {
  data() {
    return {
      maintenanceMode: false,
    }
  },
  async created() {
    await this.checkMaintenance()
  },
  methods: {
    async checkMaintenance() {
      await useJwt.axiosIns.get('settings/MaintenanceMode')
        .then(response => {
          this.maintenanceMode = response.data
          if (this.maintenanceMode) {
            this.$router.push({ name: 'maintenance' })
          } else {
            this.getSsoLoginUrl()
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    async getSsoLoginUrl() {
      await useJwt.axiosIns.get('settings/SsoLoginUrl')
        .then(response => {
          this.ssoLoginUrlInProgress = false

          if (response.data) {
            this.ssoLoginUrl = response.data
            // Redirecting to external SSO login page
            window.location.href = this.ssoLoginUrl
          } else {
            // Redirecting to regular login page
            this.$router.push({ name: 'auth-login-local' })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
